export const steps = {
  unit: {
    id: 1,
    label: 'Unit details',
    intlKey: 'wizard.unit_details',
    completed: false,
    active: true,
    path: '/unit-details',
    next: '/contact-details',
    allowedPaths: ['/contact-details']
  },
  leader: {
    id: 2,
    label: 'Contact details',
    intlKey: 'wizard.contact_details',
    completed: false,
    active: true,
    path: '/contact-details',
    next: '/leader-details',
    allowedPaths: ['/unit-details', '/leader-details']
  },
  contact: {
    id: 3,
    label: 'Leader details',
    intlKey: 'wizard.leader_details',
    completed: false,
    active: true,
    path: '/leader-details',
    next: '/account',
    allowedPaths: ['/contact-details', '/account']
  },
  account: {
    id: 4,
    label: 'ORB Account',
    intlKey: 'wizard.orb_account',
    completed: false,
    active: true,
    path: '/account',
    next: '/success',
    allowedPaths: ['/leader-details', '/success']
  }
}

const rootPath = '/register/leader'

export const wizard = Object.keys(steps).map(item => {
  const currentStep = steps[item]
  let allowedPaths = currentStep.allowedPaths.concat(currentStep.next)

  allowedPaths = currentStep.allowedPaths.map(
    allowedPath => rootPath + allowedPath
  )

  return {
    id: currentStep.id,
    label: currentStep.label,
    completed: false,
    active: currentStep.active,
    intlKey: currentStep.intlKey,
    next: rootPath + currentStep.next,
    path: rootPath + currentStep.path,
    rootPath,
    allowedPaths
  }
})
